module.exports = __webpack_public_path__ + "static/media/faq-bg.96d89402.svg";